import moment from 'moment'
import { toLower } from 'ramda'

/**
 * Возвращает локализованный индекс дня недели по названию (длинному или короткому).
 */
export const getWeekdayLocalizedNumber = (weekday: string) => {
  const localeWeekdays = [...moment.weekdaysShort(true), ...moment.weekdays(true)].map(toLower)
  const index = localeWeekdays.indexOf(toLower(weekday))
  return index > 6 ? index - 7 : index
}
